// getRabbitSignTemplates
export const GET_RABBIT_SIGN_TEMPLATES_START = 'GET_RABBIT_SIGN_TEMPLATES_START';
export const GET_RABBIT_SIGN_TEMPLATES_SUCCESS = 'GET_RABBIT_SIGN_TEMPLATES_SUCCESS';
export const GET_RABBIT_SIGN_TEMPLATES_FAIL = 'GET_RABBIT_SIGN_TEMPLATES_FAIL';
// saveRabbitSignTemplate
export const SAVE_RABBIT_SIGN_TEMPLATE_START = 'SAVE_RABBIT_SIGN_TEMPLATE_START';
export const SAVE_RABBIT_SIGN_TEMPLATE_SUCCESS = 'SAVE_RABBIT_SIGN_TEMPLATE_SUCCESS';
export const SAVE_RABBIT_SIGN_TEMPLATE_FAIL = 'SAVE_RABBIT_SIGN_TEMPLATE_FAIL';
// deleteRabbitSignTemplate
export const DELETE_RABBIT_SIGN_TEMPLATE_START = 'DELETE_RABBIT_SIGN_TEMPLATE_START';
export const DELETE_RABBIT_SIGN_TEMPLATE_SUCCESS = 'DELETE_RABBIT_SIGN_TEMPLATE_SUCCESS';
export const DELETE_RABBIT_SIGN_TEMPLATE_FAIL = 'DELETE_RABBIT_SIGN_TEMPLATE_FAIL';
// getRabbitSignTemplateById
export const GET_RABBIT_SIGN_TEMPLATE_BY_ID_START = 'GET_RABBIT_SIGN_TEMPLATE_BY_ID_START';
export const GET_RABBIT_SIGN_TEMPLATE_BY_ID_SUCCESS = 'GET_RABBIT_SIGN_TEMPLATE_BY_ID_SUCCESS';
export const GET_RABBIT_SIGN_TEMPLATE_BY_ID_FAIL = 'GET_RABBIT_SIGN_TEMPLATE_BY_ID_FAIL';
// validateRabbitSignSubscription
export const VALIDATE_RABBIT_SIGN_SUBSCRIPTION_START = 'VALIDATE_RABBIT_SIGN_SUBSCRIPTION_START';
export const VALIDATE_RABBIT_SIGN_SUBSCRIPTION_SUCCESS = 'VALIDATE_RABBIT_SIGN_SUBSCRIPTION_SUCCESS';
export const VALIDATE_RABBIT_SIGN_SUBSCRIPTION_FAIL = 'VALIDATE_RABBIT_SIGN_SUBSCRIPTION_FAIL';
// searchRabbitSignDocuments
export const SEARCH_RABBIT_SIGN_DOCUMENTS_START = 'SEARCH_RABBIT_SIGN_DOCUMENTS_START';
export const SEARCH_RABBIT_SIGN_DOCUMENTS_SUCCESS = 'SEARCH_RABBIT_SIGN_DOCUMENTS_SUCCESS';
export const SEARCH_RABBIT_SIGN_DOCUMENTS_FAIL = 'SEARCH_RABBIT_SIGN_DOCUMENTS_FAIL';
// refreshRabbitSignDocument
export const REFRESH_RABBIT_SIGN_DOCUMENT_START = 'REFRESH_RABBIT_SIGN_DOCUMENT_START';
export const REFRESH_RABBIT_SIGN_DOCUMENT_SUCCESS = 'REFRESH_RABBIT_SIGN_DOCUMENT_SUCCESS';
export const REFRESH_RABBIT_SIGN_DOCUMENT_FAIL = 'REFRESH_RABBIT_SIGN_DOCUMENT_FAIL';
// sendRabbitSignDocumentReminder
export const SEND_RABBIT_SIGN_DOCUMENT_REMINDER_START = 'SEND_RABBIT_SIGN_DOCUMENT_REMINDER_START';
export const SEND_RABBIT_SIGN_DOCUMENT_REMINDER_SUCCESS = 'SEND_RABBIT_SIGN_DOCUMENT_REMINDER_SUCCESS';
export const SEND_RABBIT_SIGN_DOCUMENT_REMINDER_FAIL = 'SEND_RABBIT_SIGN_DOCUMENT_REMINDER_FAIL';
// cancelRabbitSignDocument
export const CANCEL_RABBIT_SIGN_DOCUMENT_START = 'CANCEL_RABBIT_SIGN_DOCUMENT_START';
export const CANCEL_RABBIT_SIGN_DOCUMENT_SUCCESS = 'CANCEL_RABBIT_SIGN_DOCUMENT_SUCCESS';
export const CANCEL_RABBIT_SIGN_DOCUMENT_FAIL = 'CANCEL_RABBIT_SIGN_DOCUMENT_FAIL';
// downloadExternalRabbitSignDocument
export const DOWNLOAD_EXTERNAL_RABBIT_SIGN_DOCUMENT_START = 'DOWNLOAD_EXTERNAL_RABBIT_SIGN_DOCUMENT_START';
export const DOWNLOAD_EXTERNAL_RABBIT_SIGN_DOCUMENT_SUCCESS = 'DOWNLOAD_EXTERNAL_RABBIT_SIGN_DOCUMENT_SUCCESS';
export const DOWNLOAD_EXTERNAL_RABBIT_SIGN_DOCUMENT_FAIL = 'DOWNLOAD_EXTERNAL_RABBIT_SIGN_DOCUMENT_FAIL';
